/*
 * payment-channels translations for the "en" locale.
 *
 * Split out of locales/en.js so this feature's copy stops shipping to
 * every route in the app. See locales/payment-channels/index.js.
 */
export default {
    hero_section: {
      title: "Explore Contact’s Primary payment channels",
      subtitle:
        "At Contact, we make finance payments simple, secure, and convenient",
      description:
        "With 25 years of trusted financial service, we continue to expand our payment channels, offering customers a variety of payment methods that fit their lifestyle. Choose ContactNow app to pay your installments quickly and safely anytime, anywhere. Enjoy flexibility, ease, and peace of mind with Contact’s integrated payment network, designed to keep your payments seamless and stress-free.",
    },
    img_paragraph_section: {
      title: "How to easily pay your installments with Contact?",
      subtitle: "",
      description: `<p>With Contact, paying your installments is easier than ever and completely hassle-free. We offer multiple flexible payment options so you can choose what suits you best and pay at the time and place that’s most convenient for you. You can settle your installment effortlessly through the Contact Now app with quick and secure steps or visit the nearest Contact Branch. All our payment methods are designed to save you time and make your payment experience smooth, no queues, no effort.</p>`,
      cta1: "Pay through the Contact Now app, and we’ll handle the rest",
      cta2: "Or through our branches",
      cta_btn: "Our Branches",
    },
    channels_section: {
      title: "Pay Smarter with Contact’s Wide Range of Payment Methods",
      description: `
            <p><strong>Experience</strong> seamless and secure online installment payment with Contact through contactnow app . In addition to the availability of payment services through the branches.</p>
            <p>You can conveniently pay through Fawry, InstaPay, or Bee, along with a variety of other trusted platforms.</p>
`,
      channel_subtitle: "Our E-Collection payment options include:",
      channels: [
        {
          title: "Contact Now App",
          logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/channels_logo/contact_now.svg",
        },
        {
          title: "Alahly momkn",
          logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/channels_logo/ahly_momken.svg",
        },
        {
          title: "InstaPay",
          logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/channels_logo/instapay.svg",
        },
        {
          title: "Bee (Basata)",
          logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/channels_logo/bee_basata_en.svg",
        },
        {
          title: "Masary (Basata)",
          logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/channels_logo/bee_basata_en.svg",
        },
        {
          title: "Damen",
          logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/channels_logo/damen.svg",
        },
        {
          title: "Fawry",
          logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/channels_logo/fawry.svg",
        },
        {
          title: "Opay",
          logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/channels_logo/opay.svg",
        },
        {
          title: "Superpay",
          logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/channels_logo/superpay.svg",
        },
      ],
      cta: "All currently live and ready for use!",
      soon: "Additional partners will be available soon such as:",
      soon_list: `
        <ul style="display: flex; gap: 40px; list-style-type: disc;">
          <li style="display: list-item;">Khales </li>
          <li style="display: list-item;">Egypt Post</li>
        </ul>
        `,
    },
    contact_now_section: {
      title1: "Enjoy a seamless payment",
      title2: "experience with Contact Now",
      subtitle:
        "At Contact, we’re committed to making every payment simple, fast, and convenient.",
      description: `
            <p><strong>With </strong> the  <strong>Contact Now</strong> app, customers can manage and complete their installments with ease.</p>
            <p>We provide a wide range of payment options and methods, giving you the flexibility to choose what works best for you.</p>
            <p>Beyond payments, the app also offers guidance, insights, and seamless navigation to make your financial journey smoother than ever. </p>
`,
    },
    branches: {
      title: "Contact’s Main Branches",
      description: `
        <p><strong>At</strong> Contact, we’re committed to being wherever you need us. Our main branches across Egypt are strategically located to provide convenient access and exceptional service. Each branch is staffed with skilled professionals ready to deliver expert guidance and tailored solutions to meet your needs.</p>

<p>If visiting in person isn’t convenient, our 
  <a href="https://onelink.to/frpjkg" target="_blank" rel="noopener noreferrer" style="color:#2D317F; text-decoration: underline; text-decoration-skip-ink: none;"><strong>Contact Now</strong></a>
  App allows you to manage your policies and payments anytime, anywhere.
</p>

<p>Whether you choose to connect with us at a branch or online, Contact ensures a seamless, reliable, and customer-focused experience every step of the way.</p>

<p>
  Visit us at the 
  <a href="/our-branches" target="_blank" rel="noopener noreferrer" style="color:#2D317F; text-decoration: underline; text-decoration-skip-ink: none;">nearest branch</a>
  to you, or finalize your payments through our 
  <a href="https://onelink.to/frpjkg" target="_blank" rel="noopener noreferrer" style="color:#2D317F; text-decoration: underline; text-decoration-skip-ink: none;"><strong>Contact Now</strong></a>
  app.
</p>

`,
    },
    faq: {
      title: "Frequently Asked Questions",
      faqs: [
        {
          question:
            "What payment channels can I use to pay my Contact installments?",
          answer: `
  <p>You can pay your Contact installments easily through a wide range of payment channels and methods available nationwide:</p>

  <p>Use the <strong>ContactNow</strong> app for a fully digital experience, or pay through our trusted partners: Alahlymomken, InstaPay (Basata), Masary (Basata), Damen, Fawry, Opay, and Superpay.
</p>

  <p>We’re also expanding our Contact payment channels to include Aman, Sahl, and Egypt Post, offering you even more payment options soon.</p>
`,
        },
        {
          question:
            "What is ContactNow, and how can I use it to pay my installments?",
          answer: `
  <p><strong>ContactNow </strong> is the official app from Contact, designed to make digital installment payments faster and simpler.</p>
  <p>It gives you full control over your financing and insurance in one place!</p>

  <strong>How to pay through ContactNow:</strong>

  <ul>
    <li>Open the ContactNow app and log in.</li>
    <li>From the main dashboard, select ‘Pay Your Bills’</li>
    <li>Choose ‘Installments’ to view your outstanding balance, due dates, and payment history.</li>
    <li>Review payment details such as the amount due and the schedule.</li>
    <li>Choose your preferred payment method and confirm the amount.</li>
    <li>Complete the transaction and receive an instant digital payment receipt.</li>
  </ul>
`,
        },
        {
          question: "How can I pay my Contact installments through Fawry?",
          answer: `
  <p>You can easily pay through Fawry using the myFawry app or at Fawry Plus stores and partner retail outlets.</p>

  <strong>Via myFawry Mobile App:</strong>
  <ul>
    <li>Go to Payment Services > Financial and Banks > Installments > Contact.</li>
    <li>Choose your installment type (auto, education, mortgage, etc.).</li>
    <li>Enter your national ID number.</li>
    <li>Select your payment method (credit, debit, or prepaid card).</li>
    <li>Confirm and complete the transaction to receive instant payment confirmation.</li>
  </ul>

  <p>At Fawry Plus or Retail Network:</p>
  <ul>
    <li>Visit any outlet displaying the Fawry logo.</li>
    <li>Provide your national ID number to the cashier.</li>
    <li>Pay using cash, debit, credit, or prepaid card.</li>
    <li>Receive your payment receipt immediately.</li>
  </ul>

  <p>Note: Minimal transaction fees apply. Payments are reflected in your Contact account within one working day.</p>
`,
        },
        {
          question: "How can I use InstaPay to pay my Contact installments?",
          answer: `
            <p>You can make online installment payments in Egypt anytime with Instapay.</p>

<strong>Steps to pay via InstaPay:</strong>
<ul>
  <li>Open the InstaPay app and go to Bill Payment.</li>
  <li>Select Financial Services and choose Contact.</li>
  <li>Choose the type of installment you want to pay.</li>
  <li>Enter your national ID number and payment amount.</li>
  <li>Review the details and confirm using your IPN PIN.</li>
</ul>

<p>Note: If your payment is successful but not reflected, contact your bank with the transaction reference number.</p>
            `,
        },
        {
          question: "Are there any new payment options coming soon?",
          answer: `
            <p>Yes, we are always innovating to serve you better!</p>

<p>Aman and Sahl will be live within the next two weeks (as of October 2025), and Egypt Post will be available soon after. These additions will make Contact payment options even more accessible nationwide.</p>

<p>Stay tuned for official updates through our website and ContactNow app!</p>
`,
        },
        {
          question:
            "What should I do if my payment doesn’t go through or appears delayed?",
          answer: `
            <p>If your payment appears pending or delayed, here’s what to do:</p>
<ul>
  <li>Check your transaction status in the app (successful, rejected, or pending).</li>
  <li>Keep your digital or printed payment receipt for reference.</li>
  <li>Rejected payments are automatically reversed. If not, contact your bank.</li>
</ul>

<p>Contact Support:</p>
<ul>
  <li>Reach us through WhatsApp, our Email, or call our hotline 16177.
</li>
  <li>You can also visit any Contact branch for assistance.</li>
</ul>

<p>Payment Channel Support:</p>
<ul>
  <li>Fawry: MyFawry app​.</li>
  <li>Instapay: <a href="https://www.instapay.eg" target="_blank">www.instapay.eg</a></li>
  <li>Masary: <a href="https://www.e-masary.com" target="_blank">www.e-masary.com</a> or call 16994</li>
  <li>Sahl: <a href="https://sahlpay.app" target="_blank">sahlpay.app</a> or 0235372501</li>
  <li>Damen: <a href="https://www.damen.com.eg" target="_blank">www.damen.com.eg</a> or Damen Cash app​.</li>
  <li>Opay: <a href="https://opayeg.com" target="_blank">opayeg.com</a> or Opay Egypt app</li>
  <li>Alahlymomken: <a href="https://alahlymomkn.com/en" target="_blank"> https://alahlymomkn.com/en </a></li>
  <li>Superpay: <a href="Super-pay.com " target="_blank"> Super-pay.com  </a></li>
</ul>
`,
        },
        {
          question:
            "Why should I choose Contact payment channels for paying installments?",
          answer: `
            <p>Contact gives you the most diversified payment options in Egypt, ensuring convenience and trust.</p>

<ul>
  <li><b>Unmatched Convenience:</b> Pay anytime, anywhere through apps or over 500,000 physical outlets.</li>

  <li><b>All-in-One Experience:</b> Manage financing, payments, and insurance in one platform with <b>ContactNow</b>.</li>

  <li><b>Digital Innovation:</b> 24+ years of experience combined with leading e-collection payment solutions like Fawry and InstaPay.</li>

  <li><b>Trusted Legacy:</b> Contact is a pioneer in non-banking financial services, backed by strong customer trust and innovation.</li>
</ul>
`,
        },
      ],
    },
    cta_section: {
      title: "You’re just one click away!",
      subtitle:
        "Pay easily through the Contact Now app, we’ve got everything else covered.",
    },
  };
